module.exports = __webpack_public_path__ + "img/avion.16b3bb3f.png";